import { ReactElement } from 'react';
import { dateService, publicConfig } from '../../../../services';
import { CertificateSkillboxModel } from './certificateSkillbox.model';
import * as S from './certificateSkillbox.styled';
import { Nullable } from '../../../../models';
import { certificateMeta } from './certificateSkillbox.meta';

export const CertificateSkillbox = ({
  certificate,
  region = publicConfig.REGION,
}: CertificateSkillboxModel): Nullable<ReactElement> => {
  const meta = certificateMeta[region];

  if (!certificate) {
    return null;
  }

  return (
    <S.CertificateSkillbox>
      <S.CertificateHeaderWrapper>
        <S.CertificateHeader>
          <S.CertificateHeaderLogo>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="139"
              height="36"
              fill="none"
            >
              <path
                fill="#fff"
                d="M42.78 19.686h11.065c0-7.831-4.766-12.073-11.065-12.073v12.073Zm11.667 7.124c-1.643.87-4.272 1.631-6.682 1.631-4.985 0-9.86-2.284-9.86-10.332 0-3.48 1.534-7.396 3.834-10.496-6.299.327-12.982 6.036-12.982 14.574 0 9.027 6.464 13.595 13.092 13.595 5.368 0 10.572-3.045 12.598-8.972Zm14.078-8.32h10.188V7.612c-6.08 0-10.188 4.024-10.188 10.876ZM58.008 35.346h9.367V8.157h-9.367v27.19ZM92.9 16.26c4.601-1.142 7.559.163 7.559 4.84v14.247h9.367V16.37c0-5.928-3.451-8.919-7.559-8.919-3.89 0-7.943 2.937-9.367 8.81ZM82.657 35.347h9.367V8.157h-9.367v27.19Zm46.122-11.963c0-8.701-7.121-9.735-13.804-7.342l-.055-.054c2.465-5.547 7.176-8.538 12.106-8.538 5.751 0 11.174 4.079 11.174 12.181v15.716h-9.367V23.384h-.054ZM10.736 35.347H0V0h10.736v35.347ZM25.361 20.61V35.24H12.215L25.361 20.61Zm97.337-.054c3.342 0 5.807 1.414 5.807 1.414L116.892 36s-3.232-2.23-3.232-6.852c0-6.09 5.04-8.592 9.038-8.592Z"
              />
            </svg>
          </S.CertificateHeaderLogo>
          <S.CertificateHeaderSite>{meta.site}</S.CertificateHeaderSite>
        </S.CertificateHeader>
      </S.CertificateHeaderWrapper>
      <S.CertificateContent>
        <S.CertificateTitle>Сертификат</S.CertificateTitle>
        <S.CertificateSubtitle>подтверждает, что</S.CertificateSubtitle>
        <S.CertificateFIO>
          <S.CertificateName id="certificate-name">
            {`${certificate.templateMeta.firstName} ${certificate.templateMeta.lastName}`}
            <S.CertificateTail className="tail">...</S.CertificateTail>
          </S.CertificateName>
        </S.CertificateFIO>
        <S.CertificateBox>
          <S.CertificateCourse>
            <S.CertificateCourseLabel>
              завершил онлайн-курс
            </S.CertificateCourseLabel>
            <S.CertificateCourseVendor>
              <svg
                width="182"
                height="40"
                viewBox="0 0 182 40"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M181.806 38.7472H176.881L168.478 28.7615L160.12 38.7472H155.226L166.027 25.8472L155.785 13.6786H160.711L168.481 22.9145L176.214 13.6786H181.107L170.936 25.8288L181.806 38.7472ZM107.463 39.3731C99.7299 39.3731 97.4074 37.4929 97.4074 37.4929V1.14554H101.179V14.3596C102.574 13.6718 104.584 13.0527 107.463 13.0527C115.1 13.0527 121.29 18.597 121.29 26.214C121.29 33.8288 115.1 39.3731 107.463 39.3731ZM107.463 16.8131C104.846 16.8131 102.699 17.8128 101.179 18.8446V34.3608C101.179 34.3608 103.202 35.615 107.463 35.615C113.016 35.615 117.519 31.7514 117.519 26.214C117.519 20.6744 113.016 16.8131 107.463 16.8131ZM84.836 1.14554H88.6072V38.7472H84.836V1.14554ZM76.0381 1.14554V38.7472H72.2669V1.14554H76.0381ZM61.5052 6.78613C59.7691 6.78613 58.3618 5.38286 58.3618 3.65171C58.3618 1.92285 59.7668 0.517285 61.5052 0.517285C63.239 0.517285 64.6486 1.92055 64.6486 3.65171C64.6463 5.38057 63.239 6.78613 61.5052 6.78613ZM49.012 38.7472L35.8128 25.5858L47.7541 13.6786H53.0867L41.1453 25.5858L54.3445 38.7472H49.012ZM32.0416 38.7472V1.14554H35.8128V25.5881V38.7494H32.0416V38.7472ZM26.0698 28.5184C26.0698 34.801 21.0499 39.3594 13.0775 39.3594C7.91975 39.3594 3.90481 36.8165 0.90625 33.9091L3.57368 30.9719C6.06865 33.3404 9.00282 35.6448 13.0247 35.6448C17.4926 35.6448 22.3078 33.1478 22.3078 28.6606C22.3078 24.9369 19.3368 22.5087 13.0982 20.5918C5.99046 18.4227 2.38023 15.4832 2.38023 9.95953C2.38023 4.48862 7.02294 -0.000915527 13.6363 -0.000915527C18.5757 -0.000915527 21.6708 2.0994 24.6786 4.78441L22.0594 7.68495C19.4196 5.35305 16.9062 3.77323 13.8203 3.77323C9.99391 3.77323 6.22501 6.23124 6.22501 9.77381C6.22501 12.9862 8.07382 15.0269 14.5998 17.0217C20.5785 18.8606 26.0698 21.7062 26.0698 28.5184ZM63.4667 38.7472H59.6955V13.6786H63.4667V38.7472ZM139.516 39.9991C131.879 39.9991 125.689 33.8265 125.689 26.2118C125.689 18.597 131.879 12.4244 139.516 12.4244C147.153 12.4244 153.343 18.597 153.343 26.2118C153.343 33.8288 147.155 39.9991 139.516 39.9991ZM139.516 16.1848C133.963 16.1848 129.46 20.6744 129.46 26.2118C129.46 31.7492 133.963 36.2387 139.516 36.2387C145.069 36.2387 149.572 31.7492 149.572 26.2118C149.572 20.6744 145.069 16.1848 139.516 16.1848Z"
                  fill="white"
                />
              </svg>
              <S.CertificateCourseTitle id="certificate-course">
                {certificate.templateMeta.courseTitle}
                <S.CertificateTail className="tail">...</S.CertificateTail>
              </S.CertificateCourseTitle>
            </S.CertificateCourseVendor>
          </S.CertificateCourse>
          <S.CertificateSigns>
            <S.CertificateSign>{meta.sign}</S.CertificateSign>
            <S.CertificateStamp>
              <img height="230" width="230" src={meta.stampUrl} alt="stamp" />
            </S.CertificateStamp>
          </S.CertificateSigns>
          <S.CertificateContacts>
            <S.CertificateContactsFIO>{meta.manager}</S.CertificateContactsFIO>
            <S.CertificateContactsCompany>
              {meta.managerPosition}
            </S.CertificateContactsCompany>
            <S.CertificateContactsCompany>
              {meta.company}
            </S.CertificateContactsCompany>
          </S.CertificateContacts>
        </S.CertificateBox>
        {certificate && (
          <S.CertificateId>
            <S.CertificateIdDate>
              {dateService.formatDate(certificate.createdAt)}
            </S.CertificateIdDate>
            <S.CertificateIdDivider />
            <S.CertificateIdValue>{`№${certificate.certificateNumber}`}</S.CertificateIdValue>
          </S.CertificateId>
        )}
        <S.CertificatePolicies
          dangerouslySetInnerHTML={{ __html: meta.policies.join(' ') }}
        />
      </S.CertificateContent>
    </S.CertificateSkillbox>
  );
};
